import { default as indexhp8YbeBTRCMeta } from "/home/vsts/work/1/s/.app/pages/index.vue?macro=true";
import { default as logout5BlR6hFR7bMeta } from "/home/vsts/work/1/s/.app/pages/logout.vue?macro=true";
import { default as logtocallback7kMsPCtYOtMeta } from "/home/vsts/work/1/s/.app/pages/logtocallback.vue?macro=true";
import { default as indexD7xNgVkOmOMeta } from "/home/vsts/work/1/s/.app/pages/password/index.vue?macro=true";
import { default as passwordTsLjrBuenvMeta } from "/home/vsts/work/1/s/.app/pages/password/password.vue?macro=true";
import { default as tokenUBmp5s3xsXMeta } from "/home/vsts/work/1/s/.app/pages/password/token.vue?macro=true";
import { default as index_46clientBo0rUtaYSQMeta } from "/home/vsts/work/1/s/.app/pages/prebooking/[[visitId]]/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.14.1592_eslint@8.57.0_rollup@4.34.8_typescript@5.8.3_vue-tsc@2.1.6/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as timeoutCVPNvFlC3sMeta } from "/home/vsts/work/1/s/.app/pages/prebooking/timeout.vue?macro=true";
import { default as index_46clientMaHEAqaVlRMeta } from "/home/vsts/work/1/s/.app/pages/reports/index.client.vue?macro=true";
import { default as issuable7moQnt1NpjMeta } from "/home/vsts/work/1/s/.app/pages/reports/reportData/issuable.ts?macro=true";
import { default as usersScEdOV6tyfMeta } from "/home/vsts/work/1/s/.app/pages/reports/reportData/users.ts?macro=true";
import { default as visitorskKvCRZrk8lMeta } from "/home/vsts/work/1/s/.app/pages/reports/reportData/visitors.ts?macro=true";
import { default as reportsgOKAH0K18aMeta } from "/home/vsts/work/1/s/.app/pages/reports/reports.ts?macro=true";
import { default as configpzbc2bISv1Meta } from "/home/vsts/work/1/s/.app/pages/skytouch/[tenantId]/config.vue?macro=true";
import { default as indexayz2wKU17dMeta } from "/home/vsts/work/1/s/.app/pages/skytouch/[tenantId]/index.vue?macro=true";
import { default as _91screenId_93rASiNsky6aMeta } from "/home/vsts/work/1/s/.app/pages/skytouch/[tenantId]/screen/[screenId].vue?macro=true";
import { default as tenantslKVD4p14wgMeta } from "/home/vsts/work/1/s/.app/pages/tenants.vue?macro=true";
import { default as locationsrqHDDYwYbRMeta } from "/home/vsts/work/1/s/.app/pages/utils/locations.ts?macro=true";
import { default as mocaEventsk9N7kDVRE2Meta } from "/home/vsts/work/1/s/.app/pages/utils/mocaEvents.ts?macro=true";
import { default as visitorsMjNUQPx78iMeta } from "/home/vsts/work/1/s/.app/pages/utils/visitors.ts?macro=true";
import { default as _91visitorId_93_46clientNftXwsfIGRMeta } from "/home/vsts/work/1/s/.app/pages/visitor-edit/[visitId]/[visitorId].client.vue?macro=true";
import { default as _91visitorId_93_46client6FCYfGifZtMeta } from "/home/vsts/work/1/s/.app/pages/visitor-self-update/[tenantId]/[visitId]/[visitorId].client.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexhp8YbeBTRCMeta || {},
    component: () => import("/home/vsts/work/1/s/.app/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logout5BlR6hFR7bMeta || {},
    component: () => import("/home/vsts/work/1/s/.app/pages/logout.vue")
  },
  {
    name: "logtocallback",
    path: "/logtocallback",
    component: () => import("/home/vsts/work/1/s/.app/pages/logtocallback.vue")
  },
  {
    name: "password",
    path: "/password",
    meta: indexD7xNgVkOmOMeta || {},
    component: () => import("/home/vsts/work/1/s/.app/pages/password/index.vue")
  },
  {
    name: "password-password",
    path: "/password/password",
    meta: passwordTsLjrBuenvMeta || {},
    component: () => import("/home/vsts/work/1/s/.app/pages/password/password.vue")
  },
  {
    name: "password-token",
    path: "/password/token",
    meta: tokenUBmp5s3xsXMeta || {},
    component: () => import("/home/vsts/work/1/s/.app/pages/password/token.vue")
  },
  {
    name: "prebooking-visitId",
    path: "/prebooking/:visitId?",
    meta: index_46clientBo0rUtaYSQMeta || {},
    component: () => createClientPage(() => import("/home/vsts/work/1/s/.app/pages/prebooking/[[visitId]]/index.client.vue"))
  },
  {
    name: "prebooking-timeout",
    path: "/prebooking/timeout",
    component: () => import("/home/vsts/work/1/s/.app/pages/prebooking/timeout.vue")
  },
  {
    name: "reports",
    path: "/reports",
    meta: index_46clientMaHEAqaVlRMeta || {},
    component: () => createClientPage(() => import("/home/vsts/work/1/s/.app/pages/reports/index.client.vue"))
  },
  {
    name: "reports-reportData-issuable",
    path: "/reports/reportData/issuable",
    component: () => import("/home/vsts/work/1/s/.app/pages/reports/reportData/issuable.ts")
  },
  {
    name: "reports-reportData-users",
    path: "/reports/reportData/users",
    component: () => import("/home/vsts/work/1/s/.app/pages/reports/reportData/users.ts")
  },
  {
    name: "reports-reportData-visitors",
    path: "/reports/reportData/visitors",
    component: () => import("/home/vsts/work/1/s/.app/pages/reports/reportData/visitors.ts")
  },
  {
    name: "reports-reports",
    path: "/reports/reports",
    component: () => import("/home/vsts/work/1/s/.app/pages/reports/reports.ts")
  },
  {
    name: "skytouch-tenantId-config",
    path: "/skytouch/:tenantId()/config",
    component: () => import("/home/vsts/work/1/s/.app/pages/skytouch/[tenantId]/config.vue")
  },
  {
    name: "skytouch-tenantId",
    path: "/skytouch/:tenantId()",
    meta: indexayz2wKU17dMeta || {},
    component: () => import("/home/vsts/work/1/s/.app/pages/skytouch/[tenantId]/index.vue")
  },
  {
    name: "skytouch-tenantId-screen-screenId",
    path: "/skytouch/:tenantId()/screen/:screenId()",
    meta: _91screenId_93rASiNsky6aMeta || {},
    component: () => import("/home/vsts/work/1/s/.app/pages/skytouch/[tenantId]/screen/[screenId].vue")
  },
  {
    name: "tenants",
    path: "/tenants",
    component: () => import("/home/vsts/work/1/s/.app/pages/tenants.vue")
  },
  {
    name: "utils-locations",
    path: "/utils/locations",
    component: () => import("/home/vsts/work/1/s/.app/pages/utils/locations.ts")
  },
  {
    name: "utils-mocaEvents",
    path: "/utils/mocaEvents",
    component: () => import("/home/vsts/work/1/s/.app/pages/utils/mocaEvents.ts")
  },
  {
    name: "utils-visitors",
    path: "/utils/visitors",
    component: () => import("/home/vsts/work/1/s/.app/pages/utils/visitors.ts")
  },
  {
    name: "visitor-edit-visitId-visitorId",
    path: "/visitor-edit/:visitId()/:visitorId()",
    component: () => createClientPage(() => import("/home/vsts/work/1/s/.app/pages/visitor-edit/[visitId]/[visitorId].client.vue"))
  },
  {
    name: "visitor-self-update-tenantId-visitId-visitorId",
    path: "/visitor-self-update/:tenantId()/:visitId()/:visitorId()",
    component: () => createClientPage(() => import("/home/vsts/work/1/s/.app/pages/visitor-self-update/[tenantId]/[visitId]/[visitorId].client.vue"))
  }
]